"use client"

import { useLocale } from "@/lib/locale-context"
import { CountUp, Reveal } from "@/components/reveal"
import { SectionHead } from "@/components/section-head"

/**
 * The part that does the hiring. A reviewer gives this page under a
 * minute, so the strongest quantified evidence sits directly under the
 * statement, set as a table with the scale restated beneath it.
 */
export function SectionProof() {
  const { t } = useLocale()

  return (
    <section id="proof" className="shell scroll-mt-16 py-12 md:py-20" aria-labelledby="proof-heading">
      <SectionHead id="proof" index="01" title={t.proof.title} lead={t.proof.lead} />

      <div className="mt-8 md:mt-12">
        {t.proof.items.map((item, i) => (
          <Reveal key={item.figure} className="row-mark rule grid12 py-6 md:py-8">
            <p className="reveal t-small col-span-2 tabular-nums text-accent md:col-span-1">
              {`0${i + 1}`}
            </p>
            <div className="col-span-10 md:col-span-4">
              <h3 className="reveal-clip t-xl text-balance text-foreground">{item.figure}</h3>
            </div>
            <p
              className="reveal t-body col-span-12 mt-3 max-w-[58ch] text-muted-foreground md:col-span-7 md:col-start-6 md:mt-1"
              style={{ ["--d" as string]: "110ms" }}
            >
              {item.detail}
            </p>
          </Reveal>
        ))}
      </div>

      <Reveal className="grid12 mt-8">
        <span
          className="reveal-rule col-span-12 mb-4 block h-[2px] bg-foreground"
          aria-hidden="true"
        />
        {t.hero.stats.map((stat, i) => (
          <div
            key={stat.label}
            className="reveal col-span-6 mb-4 md:col-span-3 md:mb-0"
            style={{ ["--d" as string]: `${i * 80}ms` }}
          >
            <dl>
              <dt className="t-xl text-foreground">
                <CountUp target={stat.n} suffix={stat.suffix} />
              </dt>
              <dd className="t-small mt-1 max-w-[18ch] text-muted-foreground">{stat.label}</dd>
            </dl>
          </div>
        ))}
      </Reveal>
    </section>
  )
}
